import { useState, useEffect } from "react";
import { useQuery } from "@apollo/client";
import { GET_MEASUREMENTS_BY_IDS_QUERY } from "../../queries/MeasurementsQueries";

export function useMeasurements(measurementIds = []) {
  const [formattedMeasurements, setFormattedMeasurements] = useState([]);

  const { data, loading, error, refetch } = useQuery(
    GET_MEASUREMENTS_BY_IDS_QUERY,
    {
      variables: { ids: measurementIds },
      skip: !measurementIds || measurementIds.length === 0,
    }
  );

  useEffect(() => {
    if (!measurementIds || measurementIds.length === 0) {
      setFormattedMeasurements([]);
    }
  }, [measurementIds]);

  useEffect(() => {
    if (data?.measurementsByIds) {
      const rawMeasurements = data.measurementsByIds;
      const formattedMeasurements = [];

      rawMeasurements.forEach(measurement => {
        const { _id, unique_identifier, value } = measurement;

        const formattedMeasurement = {
          _id,
          unique_identifier,
          value,
        };

        formattedMeasurements.push(formattedMeasurement);
      });

      setFormattedMeasurements(formattedMeasurements);
    }
  }, [data]);

  return {
    measurements: formattedMeasurements,
    loading,
    error,
    refetch,
  };
}
